export const localConfig = {
  strapi: {
    url: "http://127.0.0.1:1337",
    graphqlUrl: "http://127.0.0.1:1337/graphql",
  },
  misc: {
    consentCookieDomain: "localhost",
  },
  googleRecaptchaSiteKey: "6LfcYvwpAAAAAOyYRPmVJr2ZBmPWqcmUHHrzcGCV",
};
